import { CSSProperties } from 'react'
import Styles from './VisualStylePreview.module.scss'
import cx from 'classnames'
import { getTextColorForBackground } from 'utils/colorHelpers'

export type TextOverlayVariant = 'bottom-left' | 'top-full-bg' | 'bottom-right-box'

export interface TextOverlayProps {
  fontStyle: CSSProperties
  variant: TextOverlayVariant
  textColor?: string
}

export const TextOverlay = ({ fontStyle, variant, textColor }: TextOverlayProps) => {
  const computedTextColor = textColor ? getTextColorForBackground(textColor) : 'white'

  const variantClassName = {
    'bottom-left': Styles.textOverlayBottomLeft,
    'top-full-bg': Styles.textOverlayTopFullBg,
    'bottom-right-box': Styles.textOverlayBottomRightBox,
  }[variant]

  const lineStyle = { backgroundColor: textColor, color: computedTextColor }

  return (
    <div className={cx(Styles.textOverlay, variantClassName)} style={fontStyle}>
      <span className={cx(Styles.textLine, Styles.textLineTop)} style={lineStyle}>
        How to Master A Stand
      </span>
      <span className={cx(Styles.textLine, Styles.textLineBottom)} style={lineStyle}>
        Out Brand
      </span>
    </div>
  )
}
